import { render } from "./DeleteSongLista.vue?vue&type=template&id=f6971642&scoped=true"
import script from "./DeleteSongLista.vue?vue&type=script&lang=js"
export * from "./DeleteSongLista.vue?vue&type=script&lang=js"

import "./DeleteSongLista.vue?vue&type=style&index=0&id=f6971642&scoped=true&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6971642"]])

export default __exports__